import styled from 'styled-components';
import { Capacitor } from '@capacitor/core';

const Page = styled.div`
  height: calc(calc((var(--vh, 1vh) * 100)));
  padding-top: 60px;

  ${Capacitor.platform === 'ios' && 'padding-top: calc(env(safe-area-inset-top) + 56px);'}
  width: 100vw;
`;

export const Styled = {
  Page,
};
